import React, { FunctionComponent as FC, useMemo } from 'react';
import './index.scss';
import { coverSVG, fig1, fig3, fig5 } from '../../common/nexusArt';
import Twinkle from '../Twinkle';


export const WAITING_LIST_URL = 'https://forms.gle/XT9oEmNmkaaM5e436';

interface WaitingListPageProps {
}

/* Closing slogan with the call to action, then the series of work */
const WaitingListPage: FC<WaitingListPageProps> = () => {
  const art = useMemo(() => ({ cover: coverSVG(), s1: fig3(), s2: fig5(), s3: fig1() }), []);

  return (
    <section className='slogan' id='series'>
      <div className='cover' id='slogancover' dangerouslySetInnerHTML={{ __html: art.cover }} />
      <Twinkle />
      <div className='lead'>
        <h2>The figure is no longer the end product. It's the engine of discovery.</h2>
        <div className='cta'>
          <a className='btn' href={WAITING_LIST_URL} target='_blank' rel='noopener noreferrer'>Join the waiting list</a>
        </div>
      </div>
      <div className='series'>
        <a className='s' href='#top'><span className='go'>Explore →</span><b>Nexus</b><span className='tag'>LLM-native figures · this site</span><svg viewBox='0 0 400 320' id='s1' dangerouslySetInnerHTML={{ __html: art.s1 }} /></a>
        <div className='s soon' aria-label='Upcoming project, name not yet announced'><span className='go'><i className='pulse'></i>Ongoing</span><b className='tbd' aria-hidden='true'><i></i></b><span className='tag'>Coming soon · stay tuned</span><svg viewBox='0 0 400 320' id='s2' aria-hidden='true' dangerouslySetInnerHTML={{ __html: art.s2 }} /></div>
        <div className='s soon' aria-label='Upcoming project, name not yet announced'><span className='go'><i className='pulse'></i>Ongoing</span><b className='tbd' aria-hidden='true'><i></i></b><span className='tag'>Coming soon · stay tuned</span><svg viewBox='0 0 400 320' id='s3' aria-hidden='true' dangerouslySetInnerHTML={{ __html: art.s3 }} /></div>
      </div>
    </section>
  )
}

export default WaitingListPage;
